import { ICommand } from 'core-ts-types';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
import { AdvisorSentFeedbackDiffQuery } from '../../../suggestions/components/plan_feedback/queries/advisor_sent_feedback_diff_query';
import { FeedbackSuggestedPlanModel } from '../plan_feedback/models/feedback_suggested_plan_model';

const DEFAULT_SUGGESTION_TITLE = 'Suggest Changes';
class SuggestionCommentDialogController {
  public open: boolean = false;
  private title: string = DEFAULT_SUGGESTION_TITLE;

  constructor(
    private commitSuggestedPlanCommand: ICommand,
    private ngAPNotificationDelegate: INotificationDelegate,
    private $state: ng.ui.IStateService,
    private ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
    private $element: ng.IAugmentedJQuery,
    private ngAPAdvisorSentFeedbackDiffQuery: AdvisorSentFeedbackDiffQuery
  ) {}

  $onChanges(changes: any) {
    this.title = this.title || DEFAULT_SUGGESTION_TITLE;
    this.open = !!this.open;
  }
  sendComment(comment: string) {
    const suggestedPlan = this.ngFeedbackSuggestedPlanModel.read();
    this.commitSuggestedPlanCommand(comment, suggestedPlan.id)
      .then((response: any) => {
        this.ngAPNotificationDelegate.success(`Suggestions and comment successfully sent.`);
        this.closeDialog();
        this.$state.go(`ap-advisor.plan.view.default`, {}, { reload: true });
      })
      .catch((error: any) => {
        this.ngAPNotificationDelegate.error(`Unable to send suggestions.`);
      });
  }
  openedChanged() {
    this.closeDialog();
  }
  closeDialog() {
    this.open = false;
  }
}

class SuggestionCommentDialogComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      open: '=',
      title: '<'
    };
    this.controller = SuggestionCommentDialogController;
    this.templateUrl =
      'capability-ng-academic-planner/src/suggestions/components/suggestion_comment_dialog/suggestion_comment_dialog.html';
  }
}

angular
  .module('capability-ng-academic-planner')
  .component('suggestionCommentDialog', new SuggestionCommentDialogComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/suggestion_comment_dialog/suggestion_comment_dialog.ts